
import React from 'react';
import HeaderExternal from '../Components/HeaderExternal';


const PaymentSecurity = () => {
  return (
    <>
      <HeaderExternal></HeaderExternal>
      <div className='container termsPrivacy mt-10'>
        <div className='row'>
          <div className='col-md-12 box_shadow'>
            <h1>Payment Security</h1>
            <p>tech.com ensures that every transaction you conduct online is in a safe and secure environment. To achieve this, tech.com uses a third-party payment gateway protected by Secured Socket Layer (SSL) technology. The process of encryption takes your credit card information and converts it into bits of code that are securely transmitted over the Internet. This scrambled data cannot be read as the information travels over the Internet. Your credit card details may be shared with our service providers or vendors to the extent deemed to be necessary. We do not take credit card information over the phone or via email.</p>
            <p>If you have any additional queries or concerns please write to us at hello@signaturejourneys.com.</p>
            <h6>
              Trans India TechnologiesS PRIVATE LIMITED <br />
              2nd Floor, Plot no 3, IFFCO Tower,<br />
              Sector 29, Gurugram Haryana <br />
              India – 122001<br />

            </h6>

          </div>

        </div>
      </div>

    </>
  )
};

export default PaymentSecurity;